angular.module('account.settings.social', [
  'account.settings.social.google',
  'account.settings.social.facebook',
  'account.settings.social.twitter'
]);


// WEBPACK FOOTER //
// ./client/src/app/account/settings/social/index.js